import { motion, AnimatePresence } from "framer-motion";
import { FaCommentDots } from "react-icons/fa";
import { FiVolume2, FiVolumeX, FiSend } from "react-icons/fi";
import { AiOutlineSetting, AiOutlineClose, AiOutlineReload } from "react-icons/ai";
import Typing from "../Typing/Typing";

const ChatUI = ({
  isOpen,
  setIsOpen,
  chatbot_name,
  toggleSound,
  isSoundEnabled,
  isAdmin,
  openThreads,
  restartChat,
  error,
  messages,
  newMessages,
  isLoading,
  input,
  setInput,
  handleKeyPress,
  handleSendMessage,
  threadId,
  messagesEndRef,
  animationVariants,
  analyzingFiles,
  statusMessage,
  inputRef
}) => {
  return (
    <div className="container">
      <AnimatePresence>
        {!isOpen && (
          <motion.div
            className="chat-button"
            onClick={() => setIsOpen(true)}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <FaCommentDots />
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="chat-window"
            variants={animationVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <div className="header">
              <h3 className="m-0 text-[18px]">{chatbot_name}</h3>
              <div className="header-icons">
                <button onClick={toggleSound} className="sound-toggle-button" title={isSoundEnabled ? "Mute sound" : "Unmute sound"}>
                  {isSoundEnabled ? <FiVolume2 /> : <FiVolumeX />}
                </button>
                {isAdmin && (
                  <button onClick={openThreads} className="settings-button" title="Admin settings">
                    <AiOutlineSetting />
                  </button>
                )}
                <button onClick={restartChat} className="restart-button" title="Start a new chat">
                  <AiOutlineReload />
                </button>
                <AiOutlineClose onClick={() => setIsOpen(false)} className="close-button" title="Close chat" />
              </div>
            </div>

            <div className="messages-container">
              {error && <div className="error-message">{error}</div>}
              {[...messages].map((message, index) => (
                <div
                  key={`${message.role}-${index}`}
                  className={`message ${message.role === "assistant" ? "bot-message" : "user-message"}`}
                >
                  <div>
                    {Array.isArray(message.content) ? (
                      message.content.map((element, i) => (
                        <p key={i} dangerouslySetInnerHTML={{ __html: element }} />
                      ))
                    ) : (
                      <p dangerouslySetInnerHTML={{ __html: message.content }} />
                    )}
                  </div>
                </div>
              ))}
              {analyzingFiles && <div className="text-sm text-left blinking-text flex items-center"><img className="h-4 mr-2" src="/assets/spinner.gif" alt="Loading" /> {statusMessage}</div>}
              {isLoading && <Typing />}
              {[...newMessages].map((message, index) => (
                <div
                  key={`${message.role}-${index}`}
                  className={`message ${message.role === "assistant" ? "bot-message" : "user-message"}`}
                >
                  <div>
                    {Array.isArray(message.content) ? (
                      message.content.map((element, i) => (
                        <p key={i} dangerouslySetInnerHTML={{ __html: element }} />
                      ))
                    ) : (
                      <p dangerouslySetInnerHTML={{ __html: message.content }} />
                    )}
                  </div>
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>

            <div className="input-container">
              <input
                ref={inputRef}
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Say hello or ask away!"
                className="input"
                disabled={analyzingFiles || !threadId}
              />
              <button
                onClick={handleSendMessage}
                className="send-button"
                disabled={isLoading || !threadId || (input && !input.trim())}
              >
                {analyzingFiles ? (
                  <img className="h-4" src="/assets/spinner.gif" alt="Loading" />
                ) : (
                  <FiSend className="h-4" />
                )}
                Send
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ChatUI;